import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "create-form"
}
const _hoisted_2 = ["initial-values"]
const _hoisted_3 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_5 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_6 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)
const _hoisted_8 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_9 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "position" }, "Position", -1)
const _hoisted_11 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_12 = { class: "cta-section flex flex-row gap-2 justify-content-end" }
const _hoisted_13 = {
  key: 1,
  class: "create-pending"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Editing channel...", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "create-complete"
}
const _hoisted_17 = { class: "cta-section flex flex-row gap-3 justify-content-end" }

import { watch, ref, onMounted } from 'vue';
import { useGuildStore } from '@/stores/GuildStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useDialogStore } from '@/stores/DialogStore';
import { GenericObject, configure, useForm } from 'vee-validate';
import * as yup from 'yup';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { Channel, EditChannelPayload } from '@/models/channel-list.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildChannelEdit',
  props: {
    props: {}
  },
  setup(__props: any) {

const guildStore = useGuildStore();
const apiStatusStore = useApiStatusStore();
const dialogStore = useDialogStore();

const props = __props;

const formValues = ref({
  name: props.props.channel.name,
  description: props.props.channel.description,
  type: props.props.channel.type,
  position: props.props.channel.position
});

const schema = yup.object({
  name: yup.string().min(4).required(),
  description: yup.string(),
  position: yup.number(),
});

const { defineField, handleSubmit, setValues, errors } = useForm({
  validationSchema: schema,
});

const [name] = defineField('name');
const [description] = defineField('description');
const [position] = defineField('position');

configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
})

onMounted(() => {
  setValues(formValues.value);
});

const onSubmit = handleSubmit (async (values: GenericObject) => {
  if(guildStore.guild){
    const body: EditChannelPayload = {
      guildId: guildStore.guild.id,
      groupId: props.props.groupId ,
      channelId: props.props.channel.id,
      name: values.name,
      description: values.description,
      position: values.position,
    }
    await guildStore.updateChannel(body);
  } else {
    console.error('Cannot edit channel, guild is undefined');
  }
});

watch(() => apiStatusStore.requestFulfilled('put_channel'), (newValue) => {
  if (newValue) {
    useDialogStore().changeHeader('Channel succesfully edited!')
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(apiStatusStore).requests.get('put_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"])),
            "initial-values": formValues.value
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(InputText), {
                modelValue: _unref(name),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                id: "name"
              }, null, 8, ["modelValue"]),
              _createElementVNode("small", _hoisted_5, _toDisplayString(_unref(errors).name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_unref(InputText), {
                modelValue: _unref(description),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(description) ? (description).value = $event : null)),
                id: "description"
              }, null, 8, ["modelValue"]),
              _createElementVNode("small", _hoisted_8, _toDisplayString(_unref(errors).description), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_unref(InputText), {
                modelValue: _unref(position),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(position) ? (position).value = $event : null)),
                id: "position",
                type: "number"
              }, null, 8, ["modelValue"]),
              _createElementVNode("small", _hoisted_11, _toDisplayString(_unref(errors).position), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(Button), {
                label: "Cancel",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(dialogStore).closeDialog()))
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Edit",
                disabled: _unref(apiStatusStore).requestPending('put_channel')
              }, null, 8, ["disabled"])
            ])
          ], 40, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestPending('put_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestFulfilled('put_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_unref(Button), {
              label: "Close",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(dialogStore).closeDialog()))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})